import { URLParserBase } from '@mdd/api';
// LOCAL KEYS SAFETY:
// This file is often marked skip-worktree locally to keep developer keys out of commits.
// If you need to change committed defaults in this file:
// 1) git update-index --no-skip-worktree src/environments/environment.test.ts
// 2) make the change and commit it
// 3) git update-index --skip-worktree src/environments/environment.test.ts

export const environment = {
    production: false,
    postHogEnabled: false,
    sentryEnabled: true,
    sentryEnvironment: 'test',
    // Keep committed defaults blank; use local values only in your skip-worktree copy.
    posthogApiKey: 'phc_yC7pmGrDsyLjBhN98iZCwoy8muzDuarUg0yas7C7Eem',
    barchartApiKey: '3f9130b9977b5bc5aa982e178d405244', // For local development, use the BARCHART_API_KEY environment variable key here. This file is ignored by git.
    googleApiKey: '',
    apiBase: <URLParserBase>{
        protocol: 'https',
        host: 'test.mydairydashboard.com',
        href: 'https://test.mydairydashboard.com'
    }
};
